import NiceModal, { useModal } from '@ebay/nice-modal-react'

import { Modal } from '@pepper/ui'

import styles from './_.module.css'

type Props = {
  actionType: string
  selectedCount: number
  updateBulkStatus: () => void
}

const LedgerActionsModal = NiceModal.create<Props>(
  ({ actionType, selectedCount, updateBulkStatus }) => {
    const modal = useModal()
    let action
    switch (actionType) {
      case 'ufp':
        action = 'Up For Payment'
        break
      case 'resolve':
        action = 'Resolved'
        break
      case 'on_hold':
        action = 'On Hold'
        break
      default:
        break
    }
    return (
      <Modal
        closable={true}
        centered={true}
        okText="Confirm"
        cancelText="Cancel"
        onOk={() => {
          updateBulkStatus()
          modal.remove()
        }}
        onCancel={() => modal.remove()}
        visible={modal.visible}
      >
        <div className={styles.modalDiv}>
          <h1>Are you sure?</h1>
          <div>
            Are you sure you want to mark {selectedCount}{' '}
            {selectedCount === 1 ? 'entry' : 'entries'} {action}?
          </div>
        </div>
      </Modal>
    )
  }
)

export default LedgerActionsModal
